import { Call, Device } from '@twilio/voice-sdk'
import { atom } from 'jotai'

export enum MODALSTATE {
  INITIAL, //Default loading state
  SHOW, //maximise or show
  HIDE, //hide or minimise
  CLOSE,
}

export enum DialerTab {
  CONTACT,
  LOG,
  CHAT,
}

export type CallStatus = {
  hold: boolean
  mute: boolean
  isKeyPadOpen: boolean
  currentLabel: 'Connecting' | 'Calling' | 'Ringing' | 'In-progress' | 'Completed' | 'Cancelled'
  callStartedTime?: Date
}

export type DialerStateType = {
  isOpen: boolean
  number: string
  isCalling: boolean
  keyPressed: string
  TwilioDevice?: Device
  TwilioCallConnection?: Call
  initCallAndPermissions?: (val: DialerStateType | string) => void
  callStatus: CallStatus
}

export const DialerStateDefaultValue: DialerStateType = {
  isOpen: false,
  number: '',
  isCalling: false,
  keyPressed: '',
  TwilioDevice: undefined,
  TwilioCallConnection: undefined,
  initCallAndPermissions: undefined,
  callStatus: {
    hold: false,
    mute: false,
    isKeyPadOpen: false,
    currentLabel: 'Connecting',
    callStartedTime: undefined,
  },
}

export const TwilioActiveDevice = atom<Device|undefined>(undefined);
export const TwilioActiveCallConnection = atom<Call|undefined>(undefined);

export const ModalAtom = atom<MODALSTATE>(MODALSTATE.INITIAL)
export const ActiveProperty = atom<number | undefined>(undefined)
export const ActiveTicket = atom<number | undefined>(undefined)
export const DialerAtom = atom<DialerStateType>(DialerStateDefaultValue)
export const CallDurationLabelAtom = atom<string>('')
export const DialerTabAtom = atom<DialerTab>(DialerTab.CONTACT)
export const SelectedResidentContactAtom = atom<any>(undefined)

export const CallContactAtom = atom<any>(undefined)
